import { Controller } from "@hotwired/stimulus"
import DragDropHandler from "./images_field/drag_drop_handler"
import FileUploader from "./images_field/file_uploader"
import FileManager from "./images_field/file_manager"
import PreviewManager from "./images_field/preview_manager"
import TableManager from "./images_field/table_manager"
import PositionManager from "./images_field/position_manager"
import IframeReloader from "./images_field/iframe_reloader"

export default class extends Controller {
  static targets = [
    "imageRow",
    "deleteButton",
    "deleteCheckbox",
    "fileInput",
    "selectedFilesMessage",
    "newFilesPreview",
    "previewContainer",
    "imagesTable",
    "positionInput",
    "dropZone",
    "dragDropRow",
    "removeButton"
  ]

  static values = {
    attributeName: String,
    fileText: String,
    filesText: String,
    deleteText: { type: String, default: 'Delete' },
    restoreText: { type: String, default: 'Restore' },
    recordType: String,
    recordId: String,
    dragHandlePath: String,
    noImagePath: String
  }

  connect() {
    this.initializeModules()
    this.setupInitialState()
  }

  initializeModules() {
    this.dragDropHandler = new DragDropHandler(this)
    this.fileUploader = new FileUploader(this)
    this.fileManager = new FileManager(this)
    this.previewManager = new PreviewManager(this)
    this.tableManager = new TableManager(this)
    this.positionManager = new PositionManager(this)
    this.iframeReloader = new IframeReloader(this)
  }

  setupInitialState() {
    this.previewManager.clearPreviews()
    this.previewManager.hidePreviewContainer()
    this.dragDropHandler.setupDropZoneClickHandler()

    this.storedFiles = []
  }

  handleDragOver(event) {
    this.dragDropHandler.handleDragOver(event)
  }

  handleDragEnter(event) {
    this.dragDropHandler.handleDragEnter(event)
  }

  handleDragLeave(event) {
    this.dragDropHandler.handleDragLeave(event)
  }

  handleDrop(event) {
    this.dragDropHandler.handleDrop(event)
  }

  previewFiles(event) {
    this.fileManager.previewFiles(event)
  }

  deleteImage(event) {
    this.tableManager.deleteImage(event)
  }

  removeTempFile(event) {
    this.fileManager.removeTempFile(event)
  }

  updatePositions(event) {
    this.positionManager.updatePositions(event)
  }

  isNewRecord() {
    return !this.hasRecordIdValue || this.recordIdValue === '' || this.recordIdValue === null
  }

  getAssetPath(assetName) {
    const pathMap = {
      'drag-handle.svg': this.dragHandlePathValue,
      'no-image.svg': this.noImagePathValue
    }
    return pathMap[assetName] || `/assets/${assetName}`
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  getFileText() {
    return this.fileTextValue || this.data.get("file-text") || "file selected"
  }

  getFilesText() {
    return this.filesTextValue || this.data.get("files-text") || "files selected"
  }

  notifySortableController() {
    const sortableController = this.application.getControllerForElementAndIdentifier(this.element, 'image-sortable')
    if (sortableController && typeof sortableController.addImageRow === 'function') {
      const newRow = this.imageRowTargets[this.imageRowTargets.length - 1]
      sortableController.addImageRow(newRow)
    }
  }
}